
import './Body.css';
import React from "react";
import socialMediaIsToxic from '../assets/images/socialMediaIsToxic.png'

function Body(props) {
    return (
        <div className="body">
            <img src={socialMediaIsToxic} alt="" className="tempLandingImage" />
        </div>
    )
}

export default Body;